import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmationModalComponent } from './confirmation-modal/confirmation-modal.component';
import { SharedModule } from '../../views/shared/shared.module';
import { ReactiveButtonsModule } from '@csspension/reactive-buttons';

@NgModule({
  imports: [CommonModule, SharedModule, ReactiveButtonsModule],
  declarations: [ConfirmationModalComponent],
  exports: [],
})
export class ConfirmationModule {}
